



// import React from 'react'
import React from 'react';
import './FacultyofSciences.css'
// import pic from '../assets/medicine.png'


// src/TopCategories.js
// import React from 'react';
import {  FcLibrary } from "react-icons/fc";
import MegaNavbar from '../Components/MegaNavbar';
import Footer from '../Components/Footer';
// import { FaGraduationCap,  SlChemistry, FaGlobe, FaCalculator, FaFlask } from 'react-icons/fa';
// import './TopCategories.css';

const categories = [
  { icon: < FcLibrary  />, name: 'Education', link: '/Education' },
  { icon: <   FcLibrary />, name: 'Economics', link: '/Economics' },
  { icon: < FcLibrary  />, name: 'English', link: '/English' },
  
  { icon: < FcLibrary />, name: 'History', link: '/History' },
  { icon: < FcLibrary />, name: 'Islamiyat', link: '/Islamiat' },
  
  { icon: < FcLibrary />, name: 'Management Sciences', link: '/Management_Sciences' },
  { icon: < FcLibrary />, name: 'Political Science', link: '/Political_Science' },
  { icon: < FcLibrary />, name: 'Psychology', link: '/Psychology' },
  { icon: < FcLibrary />, name: 'Urdu', link: '/Urdu' },
  

];

const FacultyofSciences = () => {
  return (

    <>
    <MegaNavbar/>

   
    <div className="top-categories container">
      <h2>Faculty of Social Sciences</h2>
      <div className="category-container">
        {categories.map((category, index) => (
          <div key={index} className="category-card">
            <div className="icon-container">{category.icon}</div>
            <h3>{category.name}</h3>
            <a href={category.link}>View More →</a>
          </div>
        ))}
      </div>
    </div>
<Footer/>
    </>
  
  )
}

export default FacultyofSciences
